<template>
  <div class="company-specific-info-card" :style="{ 'height': mainCardHeight }">
    <tabs :tabs="tabs" :active-tab="activeTab" :tabs-styling="tabsStyling" :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false" @startTabChange="activeTab = $event" />
    <div v-if="tabs[activeTab].id === 'value'" :style="{ 'height': 'calc(100% - 102px)', 'margin-top': '21px' }">
      <Table :checkbox="false" :loading="loading" :addRowButton="editingData"  :headers="usersHeaders" :items="entries"
        :add-row-button="false" @input="updateBlocked" :action-buttons="false" :actionButtons="editingData" :deleteActionButtonDisable="deleteActionButtonDisable" />
    </div>
    <div v-if="editingData" class="action-buttons">
      <custom-button :label="$t('Cancel')" :button-color="'#FFF'" :label-color="'#29BDF0'"
        :button-styling="actionButtonsStyling" @buttonClick="$emit('cancel-edit')" />
      <custom-button :label="$t('Save')" :button-color="'#29BDF0'" :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave" :disabled="!requiredFieldsFilled"
        @buttonClick="$emit('save-material')" />
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import Table from '@/newComponents/_Molecules/Table';
import CustomButton from '@/newComponents/_Atoms/CustomButton.vue';

export default {
  name: "ListsSpecificInfo",

  components: {
    Tabs,
    Table,
    CustomButton,
  },

  props: {
    hasChanges: {
      type: Boolean,
    },

    entries: {
      type: Array,
      required: true,
    },

    tableActiveTab: {
      type: Number,
    },

    specialDisable: {
      type: Boolean,
    },

    workspaces: {
      type: Array,
      required: true,
    },

    requiredFieldsFilled: {
      type: Boolean,
      required: true,
    },

    list: {
      type: Object,
      required: true
    },

    editingData: {
      type: Boolean
    },

    deleteActionButtonDisable: {
      type: Boolean,
      default: false
    },

    actionToExecute: {
      type: String,
    },

    canEditSystemList: {
      type: Boolean,
      default: false,
    },

    mainCardHeight: {
      type: String,
      default: 'auto'
    }
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      loading: false,
      allCompanies: [],
      editingData: false,
      // tableActiveTab: 0,
    }
  },

  watch: {
    editingData(value) {
      if (value) {
        this.activeTab = 0
      }
    },

    tableActiveTab(value) {
      if (value) {

      }
    }
  },

  computed: {
    usersHeaders() {
      return [
        {
          text: this.$i18n.tc('Label', 1),
          varName: "libelle",
          value: "libelle",
          type: "text",
          placeholder: "LABEL",
          editable: true
        },
        {
          text: this.$i18n.t('Blocked'),
          varName: "blocked",
          editable: this.actionToExecute === 'UPDATE_LIST' && this.tableActiveTab === 0 && !this.canEditSystemList ? false : true,
          type: "select",
          placeholder: "BLOCKED",
          options: [
            {
              code: true,
              name: "Yes"
            },
            {
              code: false,
              name: "No"
            }
          ],
          function: this.parseBlockedFieldValue
        },
        {
          text: this.$i18n.t('Description'),
          varName: "definition",
          value: "definition",
          type: "text",
          placeholder: "DESCRIPTION",
          editable: true
        },
        {
          text: this.$i18n.t('Index'),
          varName: "index",
          value: "index",
          editable: this.actionToExecute === 'UPDATE_LIST' && this.tableActiveTab === 0 && !this.canEditSystemList ? false : true,
          type: "number",
          placeholder: "INDEX",
        },
      ]
    },

    tabs() {
      return [
        {
          id: 'value',
          label: this.$i18n.tc("Value", 1),
        },
      ]
    },
  },

  methods: {
    updateBlocked(event) {
      this.entries[event.index].blocked = event.value;
    },

    parseBlockedFieldValue(value) {
      if (value) {
        return this.$i18n.t('Yes');
      } else {
        return this.$i18n.t('No');
      }
    }
  },
}
</script>

<style scoped>
.company-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/SystemManagement/Lists/ListsSpecificInfo.vue